export default __webpack_public_path__ + "static/media/arrow_back_purple.a1223128.svg";